import React, {useEffect} from 'react';
import ExcelJS from "exceljs";




export default function Exel(){
    return (
        <div>
            <div style={{margin: 20, padding: 10, border: "1px solid", textAlign: "center", cursor: "pointer"}} onClick={exportExcel}>
                Save Exel File
            </div>
        </div>
    )
}
